import { useSyncExternalStore } from 'react'
import { VideoEvent, VideoType } from '../../constants/enums'
import { pubSubVideo } from '../../state/pubSub'
import { GLOBAL_VIDEO_CACHE, VIDEOSTATE } from '../../state/state.video'
import { safeObj } from '../../utilities/safe'

export const getVideoPlayingStatus = (id: number) => () =>
    VIDEOSTATE[id]?.cache?.playing
const getDimensions = (videoType: VideoType) => () =>
    safeObj(GLOBAL_VIDEO_CACHE[videoType]?.dimensions)

const subPlaying = (id: number) => (callback: () => void) =>
    pubSubVideo.on(VideoEvent.PLAYING + '::' + id, callback)
const subDimensions = (videoType: VideoType) => (callback: () => void) =>
    pubSubVideo.on(VideoEvent.DIMENSIONS + '::' + videoType, callback)

export const useVideoPlaying = (id: number): boolean | null => {
    const playing = useSyncExternalStore(
        subPlaying(id),
        getVideoPlayingStatus(id),
        getVideoPlayingStatus(id),
    )

    return playing
}

export function useVideoDimensions(videoType: VideoType) {
    const dimensions = useSyncExternalStore(
        subDimensions(videoType),
        getDimensions(videoType),
        getDimensions(videoType),
    )

    return dimensions
}
